module.exports = __webpack_public_path__ + "img/language.3106b140.png";